import React, { useState, useEffect, useRef } from 'react';
import { Edit3, Eye, Save, X, FileText } from 'lucide-react';
import apiService from '../config';
import { useLanguage } from '../StoreContext/LanguageContext';

const Section15 = (setSelectedComponent) => {
  const [isEditing, setIsEditing] = useState(false);
  const [loading, setLoading] = useState(false);
  const [loadingRecords, setLoadingRecords] = useState(false);
  const [formData, setFormData] = useState({
    office_name: 'जिल्हाधिकारी कार्यालय बुलढाणा',
    branch_name: '',
    address: 'स्टेट बँक चौक- बुलढाणा पिन कोड-जि.बुलढाणा ता. 443001',
    email: 'labhur_buldana@rediffmail.com',
    phone: '07262-242411',
    file_no: 'क.कार्या/स्थान.पुरों(उन्दऱ)/नो.अ.402/025',
    date: '2025-08-22',
    recipient_details: `श्री.जिल्हाधिकारी बुलढाणा
    मार्फत समन्वय अधिकारी,भूसंपादन
    जिल्हाधिकारी कार्यालय बुलढाणा`,
    subject: 'भूसंपादन अधिनियम 2013 च्या कलम 15 (2) अंतर्गत मानता प्रदान करणे बाबत.',
    reference: 'भूसंपादन प्रकरण क्रमांक  :- ',
    content_main: `उपरोक्त विषयान्वये,भूसंपादन प्रकरण क्रमांक ---------------------- या मध्ये कलम 11 (1) खालील प्राथमिक अधिसूचना दिनांक ---------------  रोजी मंजूर करण्यात आलेली आहे.सदर अधिसूचना आवश्यक त्या सर्व ठिकाणी प्रसिद्ध करण्यात आली असून,प्रसिद्धीया अंतिम दिनांक -------------- हा मानण्यात आलेला आहे.

    उक्त प्रकरणात कलम 11 (1) खालील अधिसूचना प्रसिद्ध करण्यात आल्यानंतर विहित मुदतीत भूधारकांचे आक्षेप/हरकत अर्ज एकूण ---------- प्राप्त झालेले असता,ते निकाली काढण्यात आलेले आहे.त्यामुळे भूसंपादन अधिनियम 2013 च्या कलम 15 (2) चा अहवाल निरंक आहे.

    त्यानुसार सामे भूसंपादन अधिनियम 2013 च्या कलम 15 (2) अंतर्गत प्रकरणाला मानता प्रदान करण्यात यावी.हि विनंती.`,
    attachment: 'सहपत्र :- मुळ प्रकरण',
    signature_title: 'उपजिल्हाधिकारी भूसंपादन,',
    signature_location: '(इ.व.द.) बुलढाणा',

    // 🔹 New Section 11 fields
    section_11_office_name: '',
    section_11_branch_name: '',
    section_11_address: '',
    section_11_bhusampadan_no: '',
    section_11_date: '',
    section11_rehabilitation_rights_notice: ''
  });

  const [projectId, setProjectId] = useState(null);
  const [proposalId, setProposalId] = useState(null);
  const [objectionCount, setObjectionCount] = useState(0);
  const { language, translations } = useLanguage();

  const documentRef = useRef(null);

  const ROLES = {
    COLLECTOR: 1,
    LAO: 3,
    SAMANVAY: 6,
    PROJECT_INCHARGE: 18,
    DATA_ENTRY: 14
  };

  const userData = JSON.parse(localStorage.getItem('userData'));
  const userRole = parseInt(userData?.data?.user_role || userData?.user_role, 10);

  // Fetch projectId and proposalId similar to Section19
  useEffect(() => {
    const getProjectInfo = () => {
      const currentProjectData = localStorage.getItem('currentProjectData');
      if (currentProjectData) {
        try {
          const projectData = JSON.parse(currentProjectData);
          return {
            id: projectData.project_id || projectData.id,
            name: projectData.project_name || projectData.name
          };
        } catch (e) {
          console.error('Error parsing current project data (currentProjectData):', e);
        }
      }

      const selectedProject = localStorage.getItem('selectedProject');
      if (selectedProject) {
        try {
          const project = JSON.parse(selectedProject);
          return {
            id: project.project_id || project.id,
            name: project.project_name || project.name
          };
        } catch (e) {
          console.error('Error parsing selected project (selectedProject):', e);
        }
      }

      const userData = localStorage.getItem('userData');
      if (userData) {
        try {
          const user = JSON.parse(userData);
          const projectId = user.data?.project_id || user.project_id;
          const projectName = user.data?.project_name || user.project_name || 'Unknown Project';
          return {
            id: projectId,
            name: projectName
          };
        } catch (e) {
          console.error('Error parsing user data (userData):', e);
        }
      }
      return { id: null, name: null };
    };

    const projectInfo = getProjectInfo();
    setProjectId(projectInfo.id);
    console.log('Current Project Info:', projectInfo);
  }, []);

  useEffect(() => {
    const getProposalInfo = () => {
      const currentProposal = JSON.parse(localStorage.getItem('userData') || '{}');

      if (currentProposal) {
        try {
          return {
            proposalId: currentProposal?.data?.default_proposal ||
              currentProposal?.data?.proposal_id ||
              currentProposal?.default_proposal ||
              currentProposal?.proposal_id ||
              null
          }
        } catch (e) {
          console.error('Error parsing current project data (getProposalInfo):', e);
        }
      }
      return { proposalId: null };
    };

    const proposalInfo = getProposalInfo();
    setProposalId(proposalInfo.proposalId);
    console.log('Current Project-Proposal Info:', proposalInfo);
  }, []);

  // Fetch data when projectId and proposalId are available
  useEffect(() => {
    const fetchRecords = async () => {
      if (projectId && proposalId) {
        setLoadingRecords(true); // Start loader
        try {
          await fetchSection15Data();
          await fetchObjectionsCount();
        } catch (err) {
          console.error('Error fetching Section 15 data:', err);
        } finally {
          setLoadingRecords(false); // Stop loader
        }
      }
    };

    fetchRecords();
  }, [projectId, proposalId]);

  const fetchObjectionsCount = async () => {
    try {
      const response = await apiService.getAllGeneralObjections(projectId, proposalId);

      console.log("🔎 Objections API Response:", response);

      let objections = [];

      // Case A: API returns { status:200, data:[...] }
      if (Array.isArray(response.data)) {
        objections = response.data;
      }

      // Case B: API returns { data:{ status:200, data:[...] } }
      else if (Array.isArray(response.data?.data)) {
        objections = response.data.data;
      }

      // Case C: API returns raw array directly
      else if (Array.isArray(response)) {
        objections = response;
      }

      console.log("✅ Objections Count:", objections.length);
      setObjectionCount(objections.length);
    } catch (error) {
      console.error("❌ Error fetching objections:", error);
      setObjectionCount(0);
    }
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const fetchSection15Data = async () => {
    if (!projectId || !proposalId) {
      console.log('Invalid project or proposal ID:', { projectId, proposalId });
      return;
    }

    try {
      setLoading(true);
      const result = await apiService.getProposalPublish(projectId, proposalId);

      if (result.status === 200 && result.data) {
        const item = result.data;

        setFormData(prev => ({
          ...prev,
          email: item.section_15_email || prev.email,
          phone: item.section_15_mobile_no || prev.phone,
          file_no: item.section_15_notification || prev.file_no,
          date: item.section_15_date ? new Date(item.section_15_date).toISOString().split('T')[0] : prev.date,
          recipient_details: item.section_15_recipient_details || prev.recipient_details,
          content_main: item.section_15_content || prev.content_main,
          section_11_office_name: item.section_11_office_name || prev.section_11_office_name,
          section_11_branch_name: item.section_11_branch_name || prev.section_11_branch_name,
          section_11_address: item.section_11_address || prev.section_11_address,
          section_11_bhusampadan_no: item.section_11_bhusampadan_no || prev.section_11_bhusampadan_no,
          section_11_date: item.section_11_date ? formatDate(item.section_11_date) : prev.section_11_date,
          section11_rehabilitation_rights_notice: item.section11_rehabilitation_rights_notice
            ? formatDate(item.section11_rehabilitation_rights_notice)
            : prev.section11_rehabilitation_rights_notice,
        }));
      }
    } catch (error) {
      console.error('Error fetching Section 15 data:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const getDynamicContent = () => {
    if (!formData.content_main) return "";

    return formData.content_main
      .replace(/भूसंपादन प्रकरण क्रमांक[-\s]+/, `भूसंपादन प्रकरण क्रमांक ${formData.section_11_bhusampadan_no || ""} `)
      .replace(/प्राथमिक अधिसूचना दिनांक[-\s]+/, `प्राथमिक अधिसूचना दिनांक ${formData.section_11_date || ""} `)
      .replace(/अंतिम दिनांक[-\s]+/, `अंतिम दिनांक ${formData.section11_rehabilitation_rights_notice || ""} `)
      .replace(/भूधारकांचे आक्षेप\/हरकत अर्ज एकूण[-\s]+/, `भूधारकांचे आक्षेप/हरकत अर्ज एकूण ${objectionCount} `);
  };

  const handleSave = async () => {
    if (!proposalId) {
      alert('❌ No proposal ID found for update.');
      return;
    }

    try {
      setLoading(true);

      const updateData = {
        section_15_email: formData.email,
        section_15_mobile_no: formData.phone,
        section_15_notification: formData.file_no,
        section_15_date: formData.date,
        section_15_recipient_details: formData.recipient_details,
        section_15_content: formData.content_main,
      };

      const result = await apiService.updateProposal(proposalId, updateData);

      if (result.status === 200) {
        alert('✅ Section 15 Updated Successfully');
        setIsEditing(false);
        fetchSection15Data();
      } else {
        alert('❌ Failed to update Section 15.');
      }
    } catch (err) {
      console.error('Error updating Section 15:', err);
      alert('❌ Error while updating Section 15.');
    } finally {
      setLoading(false);
    }
  };

  const handlePrint = () => {
    const printContent = documentRef.current?.innerHTML;
    if (!printContent) {
      alert("No content available to print.");
      return;
    }

    const win = window.open("", "", "height=900,width=1200");
    win.document.write(`
      <html>
        <head>
          <title>Section 15</title>
          <style>
            /* Reset */
            @page {
          size: A4 portrait;   /* Orientation */
          margin-top: 0.19in;
          margin-bottom: 0.25in;
          margin-left: 0.81in;
          margin-right: 0.5in;
        }
        body {
          font-family: 'DVOT-Surekh', 'Mangal', 'Arial', sans-serif;
        }

            .document-container {
              max-width: 800px;
              margin: 0 auto;
            }

            .whitespace-pre-line {
              white-space: pre-line;
            }

            .contact-file {
              font-size: 12px;
              margin-bottom: 15px;
            }

            .contact-file .top {
              display: flex;
              justify-content: space-between;
              font-weight: bold;
            }

            .contact-file .bottom {
              display: flex;
              justify-content: space-between;
              font-weight: bold;
              border-top: 2px solid black;
              padding-top: 3px;
              margin-top: 3px;
            }

            .text-center { text-align: center; }
            .text-right { text-align: right; }
            .font-bold { font-weight: bold; }
            .mb-4 { margin-bottom: 1rem; }
            .ml-4 { margin-left: 1rem; }
            .ml-8 { margin-left: 2rem; }
            .my-4 { margin: 1rem 0; font-size: 20px; }
            .mt-6 { margin-top: 1.5rem; }
            .mt-12 { margin-top: 3rem; }
            .border-b { border-bottom: 2px solid black; }
            .pb-2 { padding-bottom: .5rem; }
            .ml-12 { margin-left: 3rem; }

            /* Specific print tweaks */
            p { text-align: justify; margin-bottom: 12px; }
          </style>
        </head>
        <body>
          ${printContent}
        </body>
      </html>
    `);

   win.document.close();
win.focus();
setTimeout(() => win.print(), 300);
  };

  // Loader display
  if (loadingRecords) {
    return (
      <div className="p-6 max-w-7xl mx-auto">
        <div className="flex justify-center items-center h-80">
          <div className="text-center animate-float">
            <div className="inline-flex relative">
              <div className="w-16 h-16 rounded-full border-4 border-slate-700 border-t-transparent animate-spin"></div>
              <div className="w-16 h-16 rounded-full border-4 border-purple-500 border-b-transparent border-r-transparent animate-spin absolute inset-0" style={{ animationDuration: '1.5s', animationDirection: 'reverse' }}></div>
              <div className="absolute inset-0 flex items-center justify-center">
                <FileText className="h-6 w-6 text-purple-400 animate-pulse" />
              </div>
            </div>
            <p className="text-gray-400 mt-4">कलम 15 लोड करत आहे...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="max-w-7xl mx-auto p-6">
      {/* Action Buttons */}
      <div className="flex justify-start gap-4 mb-6">
        {/* {userRole === ROLES.LAO && ( */}
        {/* Data Entry */}
        {(userRole === ROLES.LAO || userRole === ROLES.DATA_ENTRY) && (
          <button
            onClick={() => setIsEditing(!isEditing)}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors"
          >
            {isEditing ? <X size={20} /> : ""}
            {isEditing ? 'Cancel Edit' : <span>{translations[language]?.Edit}</span>}
          </button>
        )}

        <button
          onClick={handlePrint}
          className="flex items-center gap-2 px-4 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors"
        >
          {translations[language]?.Print}
        </button>
      </div>

      {/* Edit Modal */}
      {isEditing && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-lg shadow-xl max-w-6xl w-full max-h-[90vh] overflow-y-auto">
            <div className="p-6">
              <div className="flex justify-between items-center mb-6">
                <h2 className="text-2xl font-bold text-gray-800">{translations[language]?.Edit}</h2>
                <button
                  onClick={() => setIsEditing(false)}
                  className="text-gray-500 hover:text-gray-700 text-2xl font-bold"
                >
                  ×
                </button>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label className="block font-semibold text-gray-700 mb-2">
                    {translations[language]?.S15Email}
                  </label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block font-semibold text-gray-700 mb-2">
                    {translations[language]?.S15Phone}
                  </label>
                  <input
                    type="text"
                    name="phone"
                    value={formData.phone}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block font-semibold text-gray-700 mb-2">
                    {translations[language]?.S15FileNumber}
                  </label>
                  <input
                    type="text"
                    name="file_no"
                    value={formData.file_no}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div>
                  <label className="block font-semibold text-gray-700 mb-2">
                    {translations[language]?.S15Date}
                  </label>
                  <input
                    type="date"
                    name="date"
                    value={formData.date}
                    onChange={handleInputChange}
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div className="md:col-span-2">
                  <label className="block font-semibold text-gray-700 mb-2">
                    {translations[language]?.S15RecipientDetails}
                  </label>
                  <textarea
                    name="recipient_details"
                    value={formData.recipient_details}
                    onChange={handleInputChange}
                    rows="3"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>

                <div className="md:col-span-2">
                  <label className="block font-semibold text-gray-700 mb-2">
                    {translations[language]?.S15MainContent}
                  </label>
                  <textarea
                    name="content_main"
                    value={formData.content_main}
                    onChange={handleInputChange}
                    rows="6"
                    className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
                  />
                </div>
              </div>

              <div className="flex justify-end gap-4 mt-6 pt-4 border-t">
                <button
                  onClick={() => setIsEditing(false)}
                  className="px-6 py-2 border border-gray-300 text-gray-700 rounded-md hover:bg-gray-50"
                >
                  {translations[language]?.Cancel}
                </button>
                <button
                  onClick={handleSave}
                  disabled={loading}
                  className="flex items-center gap-2 px-6 py-2 bg-blue-600 text-white rounded-md hover:bg-blue-700"
                >
                  <Save size={16} />
                  {loading ? <span>{translations[language]?.Saving}</span> : <span>{translations[language]?.Save}</span>}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Document Preview */}
      <div className="bg-white shadow-lg rounded-lg overflow-hidden">
        <div
          ref={documentRef}
          className="document-container"
          style={{
            fontFamily: "'Noto Sans Devanagari', Arial, sans-serif",
            maxWidth: "800px",
            margin: "0 auto",
            padding: "40px",
            fontSize: "14px",
            lineHeight: "1.6"
          }}
        >
          {/* Header with Emblem */}
          <div className="text-center">
            <img src="/Emblem_of_India.svg" alt="Emblem" style={{ width: "60px", margin: "0 auto 10px" }} />
            <div className="font-bold text-[15px]">महाराष्ट्र शासन</div>
            <div className="font-bold text-[15px]">महसूल व वन विभाग</div>
          </div>

          {/* Office Details */}
          <div className="text-center mb-4">
            <div className="font-bold text-lg">{formData.section_11_office_name || formData.office_name}</div>
            <div className="font-bold">शाखा :- {formData.section_11_branch_name || formData.branch_name}</div>
            <div className="font-bold">{formData.section_11_address || formData.address}</div>
          </div>

          {/* Contact + File Section */}
          <div className="text-xs mb-4 contact-file">
            {/* Top Row (Email + Phone) */}
            <div className="flex justify-between font-semibold top">
              <div>ई-मेल :- {formData.email}</div>
              <div>दूरध्वनी क्रमांक :- {formData.phone}</div>
            </div>

            {/* Bottom Row (File No + Date) */}
            <div className="flex justify-between mt-1 border-t-2 border-black pt-1 font-semibold bottom">
              <div>{formData.file_no}</div>
              <div>दिनांक:- {formatDate(formData.date)}</div>
            </div>
          </div>

          {/* Recipient */}
          <div className="mb-4">
            <div className="recipient-section">
              <div className="font-bold mb-2">प्रति,</div>
              <div className="ml-4 whitespace-pre-line font-bold">{formData.recipient_details}</div>
            </div>
          </div>

          {/* Subject */}
          <div className="mb-4">
            <div className="font-bold">विषय :- {formData.subject}</div>
            <div className="font-bold ml-12">{formData.reference} {formData.section_11_bhusampadan_no}</div>
          </div>

          {/* Separator */}
          <div className="text-center text-2xl my-4">*****</div>

          <div className="mb-4">
            <div className="font-bold">महोदय,</div>
          </div>

          {/* Body */}
          <div className="mb-4 text-justify whitespace-pre-line">
            {getDynamicContent()}
          </div>

          {/* Closing */}
          <div className="mt-6">
            {formData.attachment}
          </div>

          {/* Signature */}
          <div className="text-right mt-12 font-bold">
            <div>{formData.signature_title}</div>
            <div className='mr-4'>{formData.signature_location}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Section15;